import AwbParams from '../../models/AwbParams';
import { extractAwbCodeAndNumber } from '../../utils/airwayBill';
import { CHANGE_AWB_NUMBER } from './actionTypes';

function setAwb(awbNumber: string, changed: boolean) {
  const awbParams: AwbParams = extractAwbCodeAndNumber(awbNumber);
  let data: any = awbParams;
  data.changed = changed;
  return {
    type: CHANGE_AWB_NUMBER,
    data
  }
}

function setAwbAction(awbNumber: string, changed: boolean) {

  return (dispatch: any) => {

    dispatch(setAwb(awbNumber, changed));
  };
}

export {
  setAwbAction
};